window.Bernie = window.Bernie || {};
var mod = require("-!/app-build/node_modules/cache-loader/dist/cjs.js!/app-build/node_modules/thread-loader/dist/cjs.js??ref--7-1!/app-build/node_modules/ts-loader/index.js??ref--7-2!/app-build/src/config/get-localization.ts");
Object.keys(mod).forEach(function (key) { window.Bernie[key] = mod[key]; });
module.exports = window.Bernie;